




import { defineComponent } from "@vue/composition-api"
import Content from "@/app/components/common/Content.vue"

export default defineComponent({
  components: {
    Content,
  },
  props: {
    content: String,
    large: {
      type: Boolean,
      default: false,
    },
  },
})
